import React from 'react';
import { render } from 'react-dom';
import EquipmentDealerSearch from './apps/EquipmentDealerSearch';
import PropaneSupplierSearch from './apps/PropaneSupplierSearch';

// Dealer map
const dealerRoot = document.getElementById('locator-map-dealer');
if (dealerRoot)
  render(<EquipmentDealerSearch {...dealerRoot.dataset} />, dealerRoot);

// Supplier map
const supplierRoot = document.getElementById('locator-map-supplier');
if (supplierRoot)
  render(<PropaneSupplierSearch {...supplierRoot.dataset} />, supplierRoot);
